<template>
    <div class="editDeatil js">
        <!-- <div class="wrapper-padded wrapper-spacing--h">
            <div class="contact-section">
                <div id="breadcrumbs">
                    <nav class="breadcrumbs">
                        <span class="breadcrumbs-item">
                            <a href="/">
                                <span>{{ $t('new.home') }}</span>
                            </a>
                        </span>
                        <span class="breadcrumb-divider" aria-hidden="true">/</span>
                        <span class="breadcrumbs-item">
                            <router-link to="/blogs" style="text-decoration: none;">
                                <span>{{ $t('new.blogAll') }}</span>
                            </router-link>
                        </span>
                        <span class="breadcrumb-divider" aria-hidden="true">/</span>
                        <span class="breadcrumbs-item">
                            <span>{{ $t('new.blogdetail') }}</span>
                        </span>
                    </nav>
                </div>
            </div>
        </div> -->
        <div class="main-content">
            <div class="main-content-header" data-animate data-animate-order="1">
                <div class="main-content-header-title">
                    <div class="main-content-header-title-text">
                        {{ newsDetail?.created_at_text }}
                    </div>
                    <!-- <div class="main-content-header-title-text">
                        October 03, 2025 * 1 min read
                    </div> -->

                </div>
                <h1>{{ newsDetail?.title }}</h1>
            </div>
            <div class="main-content-body">
                <!-- 加载中占位符 -->
                <div v-if="loading" class="loading-placeholder">
                    <div class="skeleton-header">
                        <div class="skeleton-date"></div>
                        <div class="skeleton-title"></div>
                    </div>
                    <div class="skeleton-image"></div>
                    <div class="skeleton-content">
                        <div class="skeleton-text long"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text long"></div>
                        <div class="skeleton-text"></div>
                        <div class="skeleton-text long"></div>
                    </div>
                </div>
                <div class="width-content" v-else-if="newsDetail != {}">
                    <div class="template-article__article">
                        <!-- <h2>{{ newsDetail?.title }}</h2> -->
                        <!-- <h2>testesw</h2> -->
                        <p>
                            <img :src="newsDetail?.image"></img>
                            <!-- <img :src="newsDetail?.image || require('@/assets/assetsNew/edit/edit.png')"></img> -->
                        </p>
                        <!-- <p class="article-p" v-html="newsDetail?.content"></p> -->
                        <!-- <p>testeswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtesteswtestesw
                        </p> -->
                    </div>
                    <div class="template-article__article-cont">
                        <div class="template-article__article-cont-inner">
                            <p v-html="newsDetail?.des"></p>
                            <p class="article-p" v-html="newsDetail?.content"></p>
                        </div>
                    </div>
                    <div class="template-article__article-footer">
                        <p v-html="newsDetail?.lasttitle"></p>
                    </div>
                    <!-- <div class="social-sharing">
                        <div class="label-font">{{ $t('new.share') }}</div>
                        <a class="standalone-icon--wrapper"
                            href="//www.facebook.com/sharer.php?u=https://2qh6230zcum0mcx3-73256927372.shopifypreview.com/blogs/all/test"
                            target="_blank" rel="noopener" aria-label="Share on Facebook">
                            <img src="@/assets/assetsNew/edit/facebook.png"></img>
                        </a>
                        <a class="standalone-icon--wrapper"
                            href="//x.com/share?url=https://2qh6230zcum0mcx3-73256927372.shopifypreview.com/blogs/all/test&amp;text=Test"
                            target="_blank" rel="noopener" aria-label="Share on X">
                            <img src="@/assets/assetsNew/edit/tuite.png"></img>
                        </a>
                        <a class="standalone-icon--wrapper"
                            href="//pinterest.com/pin/create/button/?url=https://2qh6230zcum0mcx3-73256927372.shopifypreview.com/blogs/all/test&amp;media=&amp;description="
                            target="_blank" rel="noopener" aria-label="Share on Pinterest">
                            <img src="@/assets/assetsNew/edit/pinterest.png"></img>
                        </a>
                    </div> -->
                </div>
            </div>
            <!-- <div class="back-to-edit" @click="toBlogs">
                <div class="back-to-edit-btn" data-animate data-animate-order="1">
                    {{ $t('new.backToBlogs') }}
                </div>
            </div> -->
            <!-- <div class="edit-detail-footer"> -->
            <!-- 不是轮播 -->
            <!-- <div class="width-content width-content-pc">
                    <div class="content-title" data-animate data-animate-order="2">
                        <h2>Featured articles</h2>
                    </div>
                    <div class="content-list img-animate-up" v-if="moreArticles.length > 0">
                        <div class="content-item kb-animate-up animate-up" v-for="(item, index) in moreArticles"
                            :key="index">
                            <div class="content-item-img">
                                <img :src="item?.image"></img>
                            </div>
                            <div class="content-item-time">
                                <p>{{ item?.created_at_text }}</p>
                            </div>
                            <h5 class="content-item-title">{{ item?.title }}</h5>
                            <div class="content-item-text">
                                <p class="article-p" v-html="item?.content"></p>
                            </div>
                            <div class="content-item-more" @click="readMore(item)">
                                {{ $t('new.readMore') }}
                            </div>
                        </div>
                    </div>
                </div> -->
            <!-- 小屏展示轮播 -->
            <!-- <div class="width-content width-content-mobile">
                    <swiper :options="swiperOptions" class="mobile-swiper" v-if="moreArticles.length > 0">
                        <swiper-slide v-for="(item, index) in moreArticles" :key="index" class="slide">
                            <div class="content-item-img">
                                <img :src="item?.image"></img>
                            </div>
                            <div class="content-item-time">
                                <p>{{ item?.created_at_text }}</p>
                            </div>
                            <h5 class="content-item-title">{{ item?.title }}</h5>
                            <div class="content-item-text">
                                <p class="article-p" v-html="item?.content"></p>
                            </div>
                            <div class="content-item-more" @click="readMore(item)">
                                {{ $t('new.readMore') }}
                            </div>
                        </swiper-slide>
                        <div class="swiper-pagination slot=" slot="pagination"></div>
                    </swiper>
                </div> -->
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { getNewsDetail } from '@/api/komo'
export default {
    components: {
        Swiper,
        SwiperSlide
    },
    data () {
        return {
            id: 0,
            newsDetail: {},
            moreArticles: [],
            loading: true,
            swiperOptions: {
                initialSlide: 0,
                // autoplay: {
                //     delay: 10000, // 自动切换时间间隔
                //     disableOnInteraction: false // 用户操作后是否停止自动切换，默认为true
                // },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true    // 允许点击切换
                },
                loop: false, // 循环模式选项
                autoHeight: true
            },
            contentList: [
                {
                    img: require('@/assets/assetsNew/edit/edit.png'),
                    time1: 'December 25, 2024',
                    time2: '5 min read',
                    title: 'Blog post',
                    text: 'Showcase blog posts to share new product launches or other news with your customers. Check out Shopify’s ecommerce blog for inspiration.',
                    more: 'Read more'
                },
                {
                    img: require('@/assets/assetsNew/edit/edit.png'),
                    time1: 'December 25, 2024',
                    time2: '5 min read',
                    title: 'Blog post',
                    text: 'Showcase blog posts to share new product launches or other news with your customers. Check out Shopify’s ecommerce blog for inspiration.',
                    more: 'Read more'
                },
                {
                    img: require('@/assets/assetsNew/edit/edit.png'),
                    time1: 'December 25, 2024',
                    time2: '5 min read',
                    title: 'Blog post',
                    text: 'Showcase blog posts to share new product launches or other news with your customers. Check out Shopify’s ecommerce blog for inspiration.',
                    more: 'Read more'
                }
            ]
        }
    },
    watch: {
        '$route': {
            immediate: true,
            handler (to) {
                console.log('watch', to);
                if (to.name === 'theEditDetail') {
                    const newId = to.params.id;
                    // 只有当 ID 真正改变时才重新加载数据
                    if (this.id !== newId) {
                        this.newsDetail = {};
                        this.moreArticles = [];
                        this.id = newId;
                        this.getNewsDetailData(this.id);
                    }
                }
            }
        }
    },
    created () {
        // 页面初次加载时获取数据
        if (this.$route.name === 'theEditDetail') {
            this.id = this.$route.params.id;
            this.getNewsDetailData(this.id);
        }
    },
    methods: {
        toBlogs () {
            // this.$router.push({ name: 'blogs' });
            this.$router.go(-1);
        },
        // 刷新页面暂时只跳转到顶部(示例官网是这样演示的)
        readMore (item) {
            console.log('item', item);
            window.scrollTo(0, 0);
            this.newsDetail = {};
            this.moreArticles = [];
            this.id = item.id;
            this.getNewsDetailData(this.id);
        },
        // 获取博客详情
        async getNewsDetailData (id) {
            try {
                this.loading = true; // 开始加载
                // 在请求前重置数据
                this.newsDetail = {};
                this.moreArticles = [];

                const res = await getNewsDetail(id);
                // 添加检查确保组件仍然挂载
                if (res && res.data?.list) {
                    this.newsDetail = res.data.list;
                    this.moreArticles = res.data.more_list;
                } else {
                    this.newsDetail = {};
                    this.moreArticles = [];
                }
                console.log('获取新闻详情:', this.newsDetail);
            } catch (error) {
                console.error('获取新闻详情失败:', error);
                this.newsDetail = {};
                this.moreArticles = [];
            } finally {
                this.loading = false; // 加载完成
                this.initIntersectionObserver()
            }
        },
        initIntersectionObserver () {
            this.$nextTick(() => {
                const textElements = this.$el.querySelectorAll('[data-animate]');
                const imgUpElemnts = this.$el.querySelectorAll('.img-animate-up .kb-animate-up');
                const allElements = [...textElements, ...imgUpElemnts];
                if (allElements.length > 0) {
                    textElements.forEach(element => {
                        element.classList.remove('animate-trigger');
                    });
                    imgUpElemnts.forEach(element => {
                        element.classList.remove('in-viewport');
                    });

                    // 创建交叉观察器
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            const element = entry.target;

                            if (entry.isIntersecting) {
                                if (element.hasAttribute('data-animate')) {
                                    // 添加动画触发类
                                    element.classList.add('animate-trigger');
                                }
                                if (element.classList.contains('kb-animate-up')) {
                                    element.classList.add('in-viewport');
                                }

                            } else {
                                // 元素离开视口（支持重复动画）
                                if (element.hasAttribute('data-animate')) {
                                    element.classList.remove('animate-trigger');
                                } else if (element.classList.contains('kb-animate-up')) {
                                    element.classList.remove('in-viewport');
                                }
                            }
                        });
                    }, {
                        threshold: 0.1, // 当10%的元素可见时触发
                        rootMargin: '0px 0px -50px 0px' // 提前50px触发
                    });

                    // 开始观察所有元素
                    allElements.forEach(element => {
                        observer.observe(element);
                    });
                }
            });
        }
    },

    mounted () {

    },
}
</script>
<style scoped lang="scss">
.editDeatil {
    padding: var(--nav-max-height) 0 0;
    display: block;
    color: #422B20;
}

.wrapper-padded {
    margin: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    position: relative;
    max-width: 1660px;
}

.wrapper-spacing--h {
    padding-left: 60px;
    padding-right: 60px;
}

#breadcrumbs {
    margin: 0;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 60px;
    padding-right: 60px;

    .breadcrumbs {
        font-size: 0;

        .breadcrumbs-item {
            margin-right: 10px;
            display: inline-block;
            font-size: 12px;

            a {
                color: var(--font-color);

                span {
                    display: inline-block;
                    padding-bottom: 0;
                    font-family: var(--label-font-stack);
                    font-weight: var(--label-font-weight);
                    font-style: var(--label-font-style);
                    text-transform: var(--label-font-case);
                    letter-spacing: var(--label-spacing);
                }
            }
        }

        .breadcrumbs-item:not(:first-child) {
            margin-left: 10px;
        }

        .breadcrumb-divider {
            font-size: 12px;
        }
    }
}

.main-content-header {
    padding: 60px 60px 0 60px;
    text-align: center;

}

.main-content-header-title-text {
    font-size: 12px;
    font-family: var(--body-font-stack);
    opacity: .7
}

.main-content-header h1 {
    margin: 0;
    font-size: var(--h1-size);
    font-family: 'Lato', sans-serif;
    font-weight: 700;
}

.main-content-body {
    padding: 60px;
}

.width-content {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
}

.template-article__article h2 {
    font-size: var(--h2-size);
    font-family: var(--header-font-stack);
    font-weight: 700;
}

.template-article__article img {
    width: 100%;
    max-width: 100%;
}

.template-article__article p {
    width: 100%;
    word-break: break-word;
    /* 中文/英文都能换行 */
    overflow-wrap: anywhere;
    /* 兼容性更好 */
    font-size: var(--base-font-size);
    line-height: 1.6;
    font-family: var(--body-font-stack);
}

.template-article__article-cont {
    margin: 0 auto;
    max-width: 100%;
    width: 100%;
    font: 1rem / 1.5 SuisseIntl, sans-serif;
}

.template-article__article-cont-inner {
    display: flex;
    margin: 1.875rem 0;
    text-align: left;
    gap: 28px;
    justify-content: center;
}

.template-article__article-cont p {
    width: 100%;
    word-break: break-word;
    /* 中文/英文都能换行 */
    overflow-wrap: anywhere;
    /* 兼容性更好 */
    font-size: var(--base-font-size);
    line-height: 1.6;
    font-family: var(--body-font-stack);
}

.template-article__article-footer {
    margin: 0 auto;
    max-width: 100%;
    width: 100%;
}

.template-article__article-footer p {
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    font-family: 'Noto Sans SC', '思源黑体', sans-serif;
}

.article-p :deep(p) {
    width: 100%;
    word-break: break-word;
    /* 中文/英文都能换行 */
    overflow-wrap: anywhere;
    /* 兼容性更好 */
    font-size: var(--base-font-size);
    line-height: 1.6;
    font-family: var(--body-font-stack);
    margin: 0;
}

.article-p :deep(img) {
    // display: none;
    width: 100%;
}

.social-sharing {
    bottom: 0;
    opacity: 1;
    position: relative;
    right: 0;
    text-align: left;
    margin-top: 15px;
}

.label-font {
    font-family: var(--label-font-stack);
    font-weight: var(--label-font-weight);
    font-style: var(--label-font-style);
    text-transform: var(--label-font-case);
    letter-spacing: var(--label-spacing);
    font-size: var(--base-font-size);
    line-height: 1.6;
}

.standalone-icon--wrapper {
    min-width: 44px;
    min-height: 44px;
    padding: 12px !important;
    display: inline-flex;
}

.standalone-icon--wrapper img {
    width: 20px;
    height: 20px;
}

.back-to-edit {
    background: #e8e2d9;
    padding: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.back-to-edit-btn {
    width: 236px;
    height: 42px;
    border-radius: 42px;
    background: #442d22;
    color: #e8e2d9;
    font-size: 14px;
    line-height: 42px;
    text-align: center;
    font-family: var(--body-font-stack);
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.back-to-edit-btn:hover:after {
    background-image: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, .25), transparent);
    content: "";
    height: 100%;
    left: 150%;
    position: absolute;
    top: 0;
    transform: skew(-20deg);
    width: 200%;
    animation: shineAgain .75s cubic-bezier(.01, .56, 1, 1);
}

.edit-detail-footer {
    padding: 60px;
}

.width-content {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
}

.content-title {
    margin-bottom: 50px;
}

.content-title h2 {
    font-size: var(--h2-size);
    margin: 0;
    font-family: var(--header-font-stack);
    font-weight: 700;
    text-align: center;
}

.content-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.content-item {
    grid-column: span 1;
}

.content-item-img {
    width: 100%;
    margin-bottom: 10px;
}

.content-item-img img {
    width: 100%;
}

.content-item-time {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 2px;
    font-size: 12px;
    opacity: .7;
}

.content-item-time p {
    margin: 0;
}

.content-item-title {
    font-size: var(--h2-size);
    margin: 0;
    font-family: var(--header-font-stack);
    font-weight: 600;
    margin-bottom: 10px;
}

.content-item-text {
    margin-bottom: 10px;
}

.content-item-text p {
    margin: 0 0 15px 0;
    font-size: var(--base-font-size);
    font-family: var(--label-font-stack);
}

.content-item-more {
    cursor: pointer;
    font-size: var(--base-font-size);
    font-family: var(--label-font-stack);
}

.width-content-mobile {
    display: none;
}

@media print,
screen and (min-width: 64em) {
    .template-article__article-cont {
        max-width: 85%;
    }

    .template-article__article-cont-inner p:first-child {
        width: 32%;
    }

    .template-article__article-cont-inner p:nth-child(2) {
        width: 50%;
    }

    .template-article__article-footer {
        max-width: 85%;
    }
}

@media (max-width: 765px) {
    .wrapper-padded {
        padding: 0 15px;
    }

    #breadcrumbs {
        padding-left: 0px;
        padding-right: 0px;
    }

    .main-content-header {
        padding: 30px 15px 0 15px;
    }

    .main-content-body {
        padding: 15px;
    }

    .edit-detail-footer {
        padding: 45px 15px;
    }

    .width-content-pc {
        display: none;
    }

    .width-content-mobile {
        display: block;

    }

    .mobile-swiper {
        padding-bottom: 45px;
    }

    :deep(.swiper-pagination-bullet) {
        width: 12px;
        height: 12px;
        background: #ddd;
        opacity: 1;
    }

    :deep(.swiper-pagination-bullet-active) {
        background: rgba(66, 43, 32, 1);
    }

    :deep(.swiper-pagination) {
        bottom: 0px !important;
    }

    .template-article__article-cont-inner {
        display: flex;
        flex-direction: column;
        margin: 1.875rem 0;
        text-align: left;
        gap: 28px;
        justify-content: center;
    }
}



/* 图片动画 - 从下到上 */
.animate-up {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.8s ease, transform 0.8s ease;
}

.kb-animate-up.in-viewport.animate-up {
    opacity: 1;
    transform: translateY(0);
}

.img-animate-up .content-item:nth-child(1) {
    transition-delay: 0s;
}

.img-animate-up .content-item:nth-child(2) {
    transition-delay: 0.15s;
}

.img-animate-up .content-item:nth-child(3) {
    transition-delay: 0.3s;
}

.loading-placeholder {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 60px;

    .skeleton-header {
        text-align: center;
        margin-bottom: 30px;

        .skeleton-date {
            width: 150px;
            height: 12px;
            background: #f0f0f0;
            margin: 0 auto 15px;
            border-radius: 4px;
            animation: skeleton-loading 1.5s infinite;
        }

        .skeleton-title {
            width: 60%;
            height: 32px;
            background: #f0f0f0;
            margin: 0 auto;
            border-radius: 4px;
            animation: skeleton-loading 1.5s infinite;
        }
    }

    .skeleton-image {
        width: 100%;
        height: 400px;
        background: #f0f0f0;
        margin-bottom: 30px;
        border-radius: 4px;
        animation: skeleton-loading 1.5s infinite;
    }

    .skeleton-content {
        .skeleton-text {
            width: 100%;
            height: 16px;
            background: #f0f0f0;
            margin-bottom: 15px;
            border-radius: 4px;
            animation: skeleton-loading 1.5s infinite;

            &.long {
                width: 90%;
            }

            &:nth-child(3) {
                width: 95%;
            }
        }
    }
}

@keyframes skeleton-loading {
    0% {
        background-color: #f0f0f0;
    }

    50% {
        background-color: #e0e0e0;
    }

    100% {
        background-color: #f0f0f0;
    }
}


@media (max-width: 1115px) {
    .editDeatil {
        padding: var(--nav-1115-height) 0 0;
    }
}

@media (max-width: 990px) {
    .editDeatil {
        padding: var(--nav-990-height) 0 0;
    }
}

@media only screen and (min-width: 768px) {
    .breadcrumbs a {
        background-color: transparent !important;
        background-image: linear-gradient(to top, currentColor 0, currentColor 0), linear-gradient(to top, transparent 0, transparent 0);
        background-repeat: no-repeat;
        background-position: left bottom, left bottom;
        background-size: 0 1px, 100% 1px;
        transition-property: background-size;
        transition-timing-function: ease;
        transition-duration: .25s;
    }

    .breadcrumbs a:hover {
        background-position: left bottom, left bottom;
        background-size: 100% 1px, 100% 1px;
    }
}

@media (max-width: 765px) {
    .loading-placeholder {
        padding: 0 15px;

        .skeleton-image {
            height: 200px;
        }
    }
}
</style>